import { getBoundFrom2DArray } from 'features/fde'
import {
  AhpScenario,
  ForecastComponentConfig,
  GeckoAssetModel,
  GeckoComponentDataFrame,
  GeckoInspection,
} from 'types'

import { useCalculateAssetHealthPlan } from './useCalculateAssetHealthPlan'

export function useCalculateRemainingLifeDelta({
  relevantThicknessCDF,
  thicknessValues2dArray,
  forecastComponentConfig,
  assetHealthPlanScenarios,
  selectedInspection,
  assetModel,
}: {
  relevantThicknessCDF: GeckoComponentDataFrame | undefined
  thicknessValues2dArray:
    | number[][]
    | readonly (readonly number[])[]
    | undefined
  forecastComponentConfig: ForecastComponentConfig
  assetHealthPlanScenarios: AhpScenario[]
  selectedInspection: GeckoInspection | undefined
  assetModel: GeckoAssetModel | undefined
}): {
  minRemainingLife: number
  isLoading: boolean
} {
  const { dataFrames: newAhpDataFrame, isLoading: newAhpDataFrameIsLoading } =
    useCalculateAssetHealthPlan({
      baseThicknessCDF: relevantThicknessCDF,
      forecastComponentConfig,
      assetHealthPlanScenarios,
      selectedInspection,
      assetModel,
      thicknessValues2dArray,
    })

  const minRl = getBoundFrom2DArray(
    newAhpDataFrame?.[newAhpDataFrame.length - 1]?.rl,
    'min'
  )

  return {
    minRemainingLife: minRl ?? 0,
    isLoading: newAhpDataFrameIsLoading,
  }
}
